module.exports = __webpack_public_path__ + "static/media/stamp_task.5f09b447.svg";